import { Model } from "types";
import { GenericMap } from "../models/types";

export interface FavoriteState {
  collection: null | Cart;
  loading: boolean;
}

export interface Cart {
  id: string;
  models: GenericMap<Model>;
  name: string;
  createdStamp: string;
  description: string;
}

export const GET_CARTS_FOR_USER = "GET_CARTS_FOR_USER";
export const GET_CARTS_FOR_USER_SUCCESS = "GET_CARTS_FOR_USER_SUCCESS";
export const GET_CARTS_FOR_USER_FAILURE = "GET_CARTS_FOR_USER_FAILURE";

export const CREATE_NEW_CART = "CREATE_NEW_CART";
export const CREATE_NEW_CART_FAILURE = "CREATE_NEW_CART_FAILURE";
export const CREATE_NEW_CART_SUCCESS = "CREATE_NEW_CART_SUCCESS";

export const UPDATE_CART = "UPDATE_CART";

export const ADD_MODEL_TO_CART = "ADD_MODEL_TO_CART";
export const ADD_MODEL_TO_CART_SUCCESS = "ADD_MODEL_TO_CART_SUCCESS";
export const ADD_MODEL_TO_CART_FAILURE = "ADD_MODEL_TO_CART_FAILURE";

export const DELETE_FAVORITES_LIST = "DELETE_FAVORITES_LIST";
export const DELETE_FAVORITES_LIST_SUCCESS = "DELETE_FAVORITES_LIST_SUCCESS";
export const DELETE_FAVORITES_LIST_FAILURE = "DELETE_FAVORITES_LIST_FAILURE";

export const EDIT_FAVORITES_LIST = "EDIT_FAVORITES_LIST";
export const EDIT_FAVORITES_LIST_SUCCESS = "EDIT_FAVORITES_LIST_SUCCESS";
export const EDIT_FAVORITES_LIST_FAILURE = "EDIT_FAVORITES_LIST_FAILURE";

export const DELETE_MODEL_FROM_CART = "DELETE_MODEL_FROM_CART";
export const DELETE_MODEL_FROM_CART_SUCCESS = "DELETE_MODEL_FROM_CART_SUCCESS";
export const DELETE_MODEL_FROM_CART_FAILURE = "DELETE_MODEL_FROM_CART_FAILURE";

export interface CreateNewCartAction {
  type: typeof CREATE_NEW_CART;
  payload: any;
}

export interface AddModelToCartAction {
  type: typeof ADD_MODEL_TO_CART;
  payload: {
    cart: string;
    model: string;
  };
}

export interface RemoveModelFromCartAction {
  type: typeof DELETE_MODEL_FROM_CART;
  payload: {
    cart: string;
    model: string;
  };
}

export interface SetCarts {
  type: typeof GET_CARTS_FOR_USER_SUCCESS
  payload: Cart[];
}

export interface UpdateCart {
  type: typeof UPDATE_CART;
  payload: Cart;
}

export type FavoriteActionsTypes = SetCarts | UpdateCart ;
